import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import { Badge, Button, CloseButton, Col, Container, FloatingLabel, Form, Image } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import CommonDialog from './common/CommonDialog';
import { Alert } from '@mui/material';

const Questionnaire = (props) => {
	async function getTerms(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/messages/terms").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t,i18n} = useTranslation()
    const location = useLocation()
	const [terms,setTerms] = useState("")
    const [deadlineDate,setDeadlineDate] = useState(props.deadlineDate)
    const [deadlineTime,setDeadlineTime] = useState(props.deadlineTime)
    const [options,setOptions] = useState(props.options.length === 0 ? [...Array(10)] : props.options)
    const [optionErrors, setOptionErrors] = useState(Array(10).fill(""));
    const [dateError, setDateError] = useState("");
    const [timeError, setTimeError] = useState("");

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    document.onkeydown = (e) => {
        if(e.key === "Escape"){
            props.switch(false)
        }
    }

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0,0,0,0.5)",
                zIndex: 1000,
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }}
        >
            <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
            <div
                id="setting-popup"
                style={{
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    boxShadow: "0 4px 32px rgba(0,0,0,0.18)",
                    width: "100%",
                    maxWidth: "480px",
                    minWidth: "320px",
                    maxHeight: "90vh",
                    overflowY: "auto",
                    padding: "32px 24px 24px 24px",
                    position: "relative"
                }}
            >
                <Button
                    variant='secondary'
                    style={{position: "absolute", top: 16, right: 16, zIndex: 2}}
                    onClick={() => props.switch(false)}
                >
                    {t("common.close")}
                </Button>
                <Container style={{marginTop: "16px", padding: 0}}>
                    <h5 className="mb-4" style={{fontWeight: "bold", textAlign: "center"}}>{t("questionnaire.title")}</h5>
                    {options.map((d,i) => {
                        let no = i + 1
                        return (
                            <Form.Group className="mb-3" controlId={"option" + no} key={i}>
                                <Form.Control type="text" placeholder={"選択肢" + no} defaultValue={d} style={{height: "48px", fontSize: "1rem"}} />
                                {optionErrors[i] && <Alert severity="error" className="mt-1 py-1">{optionErrors[i]}</Alert>}
                            </Form.Group>
                        )
                    })}
                    <FloatingLabel controlId="deadline-date" label={t("common.deadline")}
    className='mb-3 w-100'>
    <Form.Control
        type="date"
        required
        defaultValue={props.deadlineDate}
        style={{height: "48px"}}
    />
    {dateError && <Alert severity="error" className="mt-1 py-1">{dateError}</Alert>}
</FloatingLabel>
<FloatingLabel controlId="deadline-time" label={t("common.deadline")}
    className='mb-3 w-100'>
    <Form.Control
        type="time"
        required
        defaultValue={props.deadlineTime}
        style={{height: "48px"}}
    />
    {timeError && <Alert severity="error" className="mt-1 py-1">{timeError}</Alert>}
</FloatingLabel>
                    <div className="d-flex justify-content-between mt-4">
                        <Button
                            onClick={() => props.onSave(() => {
                                let deadlineDate = document.getElementById("deadline-date").value
                                let deadlineTime = document.getElementById("deadline-time").value
                                let newOptionErrors = Array(10).fill("");
                                let hasError = false;
                                // 選択肢バリデーション
                                let exists = false
                                for(let i = 0;i < 10;i++){
                                    let no = i + 1
                                    let value = document.getElementById("option"+no).value
                                    if(value.length > 0){
                                        exists = true
                                    }
                                    if(value.length > 100){
                                        newOptionErrors[i] = t("common.error") + ': 100文字以内で入力してください。';
                                        hasError = true;
                                    }
                                }
                                setOptionErrors(newOptionErrors);
                                // 日付・時間バリデーション
                                setDateError("");
                                setTimeError("");
                                if((deadlineDate.length === 0 && deadlineTime.length > 0)
                                    || (deadlineDate.length > 0 && deadlineTime.length === 0)){
                                    if(deadlineDate.length === 0) setDateError(t("common.error") + ': 日付を入力してください。');
                                    if(deadlineTime.length === 0) setTimeError(t("common.error") + ': 時間を入力してください。');
                                    hasError = true;
                                }
                                if(exists){
                                    if(deadlineDate.length === 0 || deadlineTime.length === 0){
                                        if(deadlineDate.length === 0) setDateError(t("common.error") + ': 期限日付を入力してください。');
                                        if(deadlineTime.length === 0) setTimeError(t("common.error") + ': 期限時間を入力してください。');
                                        hasError = true;
                                    }
                                } else {
                                    if(deadlineDate.length > 0 || deadlineTime.length > 0){
                                        newOptionErrors[0] = t("common.error") + ': 1件以上選択肢を入力してください。';
                                        setOptionErrors(newOptionErrors);
                                        hasError = true;
                                    }
                                }
                                if(hasError) return;
                                props.switch(false)
                                return (
                                    {"options":[...Array(10)].map((d,i) => {
                                        let no = i + 1
                                        return document.getElementById("option"+no).value
                                    }),"deadlineDate":deadlineDate,"deadlineTime":deadlineTime}
                                )
                            })}
                            className="flex-fill me-2"
                            style={{height: "48px", fontWeight: "bold"}}
                        >OK</Button>
                        <Button
                            onClick={() => {
                                document.getElementById("deadline-date").value = ""
                                document.getElementById("deadline-time").value = ""
                                setOptions([...Array(10)])
                                options.forEach((d,i) => {
                                    let no = i + 1
                                    document.getElementById("option"+no).value = ""
                                })
                            }}
                            variant='danger'
                            className="flex-fill ms-2"
                            style={{height: "48px", fontWeight: "bold"}}
                        >Reset</Button>
                    </div>
                </Container>
            </div>
        </div>
    )
}

export default Questionnaire;
